// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PlaceOrderAssetsManager from "../../assets/PlaceOrderAssetsManager.bs.js";

var vehicleImg = PlaceOrderAssetsManager.getImage("vehicle.svg");

function LoadingVehicleCardCmp(Props) {
  return React.createElement("div", {
              className: "vehicle-card__container loading"
            }, React.createElement("div", {
                  className: "sub-section loading-shimmer"
                }, React.createElement("div", {
                      className: "title"
                    }, "12 feet")), React.createElement("div", {
                  className: "sub-section loading-shimmer"
                }, React.createElement("div", {
                      className: "vehicle_img"
                    }), React.createElement("div", {
                      className: "title"
                    }, "Rs 500")), React.createElement("div", {
                  className: "sub-section loading-shimmer"
                }, React.createElement("div", {
                      className: "label"
                    }, "3 vehicles nearby"), React.createElement("div", {
                      className: "label"
                    }, "ETA: 5 mins")), React.createElement("div", {
                  className: "sub-section loading-shimmer"
                }, React.createElement("div", {
                      className: "label"
                    }, "1.5 x 1.3 x 1.8 meter"), React.createElement("div", {
                      className: "label"
                    }, "<750 KGS")));
}

var make = LoadingVehicleCardCmp;

export {
  vehicleImg ,
  make ,
  
}
/* vehicleImg Not a pure module */
